module.exports = __webpack_public_path__ + "img/product_27.a4e393a.webp";